/**
 * The places on the home page that something else on it scrolls to.
 *
 * Their own module because two parts of the page lead to them — the workspace
 * figures and the attention card's rows — and each would otherwise restate the
 * id of a card it does not draw.
 */

/** The pull-request card, which the open-reviews figure opens on its review tab. */
export const PR_WIDGET_ANCHOR_ID = 'cockpit-my-open-prs';

/** The CI health card, where every failing default branch is listed. */
export const CI_WIDGET_ANCHOR_ID = 'cockpit-ci-health';

/** Brings one of the anchors above into view, the way every lead to it does. */
export const scrollToAnchor = (id: string) => {
  document
    .getElementById(id)
    ?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
